import {h, Component, Fragment} from "preact";
import {ThreeDots} from "./prematch-tournament.jsx";

import formatOdd from "../../../services/odds-format";

export {ThreeDots} from "./prematch-tournament.jsx";

export function TitleHeader({children}) {
	return <div class="cl-pse-ttl-head flex h-8 items-center border-b border-b-harifzinc-950 bg-harifzinc-800 text-white">{children}</div>
}
export function BackButton({children, onClick}) {
	return <div class="cl-pse-backbtn flex h-8 w-9 flex-none items-center justify-center border-r border-r-harifzinc-950 pb-0.5" onClick={onClick}>{children}</div>
}

export function SportName({children}) {
	return <div class="cl-pse-sport-name min-w-0 truncate text-sm text-custom-orange">{children}</div>
}
export function TournamentName({children}) {
	return <div class="cl-pse-tourn-name min-w-0 grow truncate px-4 text-sm">{children}</div>
}
export function MatchNameBreadcrumb({children}) {
	return <span class="cl-pse-mtch-name-bread text-custom-orange">{children}</span>
}

export function PrematchEventNameRow({children}) {
	return <div class="cl-pse-pevt-name-row fn-live-event-header h-16 border-b border-t border-b-harifzinc-900 border-t-harifzinc-900 bg-harifzinc-800 p-2 px-3 text-white">{children}</div>
}
export function InfoBox({children}) {
	return <div class="cl-pse-infobox flex h-full items-center">{children}</div>
}
export function TournamentBaseInfo({children}) {
	return <div class="cl-pse-trn-baseinfo text-sm">{children}</div>
}
export function EventFullName({children}) {
	return <div class="cl-pse-evt-fullname truncate">{children}</div>
}
export function EventBaseInfo({children}) {
	return <div class="cl-pse-evt-baseinfo flex min-w-0 grow flex-col justify-between">{children}</div>
}

export function EventRapidButtons({children}) {
	return <div class="cl-pse-evt-rpd-btns flex flex-none">{children}</div>
}
export function EventRapidButtonLeft({children, active, onClick}) {
	return <div class="cl-pse-evt-rpd-btn-l flex h-8 w-8 items-center justify-center border border-r-0 border-harifzinc-900" onClick={onClick}>{children}</div>
}
export function EventRapidButtonRight({children, active, onClick}) {
	return <div class="cl-pse-evt-rpd-btn-r flex h-8 w-8 items-center justify-center border border-harifzinc-900" onClick={onClick}>{children}</div>
}

export function ScrollableTabsRail({children}) {
	return <div class="cl-pse-scroll-tab-rail scrollbar-x-fancy relative overflow-x-auto overflow-y-hidden">{children}</div>
}
export function ScrollableTabsContent({children}) {
	return <div class="cl-pse-scroll-tab-cont fn-tabs grid grid-cols-7 bg-harifzinc-700 text-sm">{children}</div>
}
export function TabButton({children, active, onClick}) {
	if (active)
		return <div 
				   class="cl-pse-tab-btn flex h-8 shrink-0 grow items-center justify-center border border-t-harif-800 border-b-harif-950 border-l-harifzinc-950 border-r-harifzinc-800 bg-harif-950 text-white px-4"
				   onClick={onClick}>
			<span class="truncate">{children}</span>
		</div>
	return <div 
			   class="cl-pse-tab-btn flex h-8 shrink-0 grow items-center justify-center border border-t-harif-800 border-b-harif-950 border-l-harifzinc-950 border-r-harifzinc-800 bg-harif-900 text-white px-4"
			   onClick={onClick}>
		<span class="truncate">{children}</span>
	</div>
}

export function MarketsContainer({children}) {
	return <div class="cl-pse-mkt-cont fn-market overflow-x-hidden">{children}</div>
}
export function MarketHeadRow({children, onClick}) {
	return <div class="cl-pse-mkt-head-row flex h-7 items-center border-b border-b-harifzinc-950 bg-harif-800 text-white" onClick={onClick}>{children}</div>
}
export function MarketCollapseButton({children, active, onClick}) {
	return <div class="cl-pse-mkt-coll-btn flex h-7 w-9 flex-none items-center justify-center border-r border-r-harifzinc-950 pb-0.5" onClick={onClick}>{children}</div>
}
export function MarketName({children}) {
	return <div class="cl-pse-mkt-name min-w-0 grow truncate px-4 text-sm">{children}</div>
}

export function OutcomesContainer({children, open}) {
	if (!open)
		return <div class="cl-pse-out-cont -mx-px text-sm hidden">{children}</div>
	return <div class="cl-pse-out-cont -mx-px text-sm">{children}</div>
}
export function OutcomesContainerRow({children, cols}) {
	return <div class={"cl-pse-out-cont-row grid "+(cols == 3 ? "grid-cols-3" : "grid-cols-2")}>{children}</div>
}

export function OutcomeButton({value, active, onClick, selected, children}) {
	if (selected)
		return <div
			class="cl-pse-out-btn cursor-pointer bg-harif-750 flex h-8 grow items-center justify-between border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 px-4 text-black "
			onClick={onClick}>
			{children}
		</div>
	return <div
		class="cl-pse-out-btn cursor-pointer bg-harif-900 flex h-8 grow items-center justify-between border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 px-4 text-black"
		onClick={onClick}>
		{children}
	</div>
}
export function OutcomeBuilderButton({value, active, onClick, selected, disabled, children}) {
	if (disabled)
		return <div
			class="cl-pse-out-btn flex h-8 grow items-center justify-between border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 px-4 text-black bg-slate-400"
				   onClick={onClick}>
			{children}
		</div>
	if (selected)
		return <div
			class="cl-pse-out-btn cursor-pointer flex h-8 grow items-center justify-between border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 px-4 text-black bg-custom-orantext-custom-orange"
				   onClick={onClick}>
			{children}
		</div>
	return <div 
			   class="cl-pse-out-btn cursor-pointer flex h-8 grow items-center justify-between border border-b-harifzinc-950 border-l-harifzinc-950 border-r-harifzinc-800 border-t-harifzinc-800 bg-harifzinc-900 px-4"
			   onClick={onClick}>
		{children}
	</div>
}
export function OutcomeName({children}) {
	return <span class="cl-pse-out-name truncate text-white">{children}</span>
}
export function OutcomeValue({value, selected}) {
	if (selected)
		return <span class="cl-pse-out-value font-bold text-white">{!!value ? formatOdd(value) : '-'}</span>
	return <span class="cl-pse-out-value font-bold text-custom-orange">{!!value ? formatOdd(value) : '-'}</span>
}

export function EventContent() {
	return <div>
	  <TitleHeader>
		<BackButton>B</BackButton>
		<ThreeDots />
		<SportName>Football</SportName>
		<TournamentName>Region - Tournament / <MatchNameBreadcrumb>Home vs. Away</MatchNameBreadcrumb></TournamentName>
	  </TitleHeader>

	  <PrematchEventNameRow>
		<InfoBox>
		  <EventBaseInfo>
			<TournamentBaseInfo>Nike FC Cup - Women</TournamentBaseInfo>
			<EventFullName>Nike FC Cup - Women</EventFullName>
		  </EventBaseInfo>
		  <EventRapidButtons>
			<EventRapidButtonLeft />
			<EventRapidButtonRight />
		  </EventRapidButtons>
		</InfoBox>
	  </PrematchEventNameRow>

	  <ScrollableTabsRail>
		<ScrollableTabsContent>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		</ScrollableTabsContent>
	  </ScrollableTabsRail>

	  <div>
		<MarketsContainer>
		  <MarketHeadRow>
			<MarketCollapseButton>B</MarketCollapseButton>
			<MarketName>Market Name</MarketName>
		  </MarketHeadRow>

		  <OutcomesContainer>
			<OutcomeButton>
			  <OutcomeName>Outcome</OutcomeName>
			  <OutcomeValue>3.10</OutcomeValue>
			</OutcomeButton>
			<OutcomeButton>
			  <OutcomeName>Outcome</OutcomeName>
			  <OutcomeValue>3.10</OutcomeValue>
			</OutcomeButton>
			<OutcomeButton>
			  <OutcomeName>Outcome</OutcomeName>
			  <OutcomeValue>3.10</OutcomeValue>
			</OutcomeButton>
		  </OutcomesContainer>
		</MarketsContainer>
	  </div>
	</div>
}
